import axios from "axios";
import config from "../../env.json";

async function getEnvironmentDetails() {
    const { data } = await axios.get(
        `${config.REACT_APP_ENV_API_BASE}/v1/environment-detail`
    );
    return data;
}

async function getTenantList(id?: number) {
    const url = id
        ? `${config.REACT_APP_ENV_API_BASE}/v1/tenant/${id}`
        : `${config.REACT_APP_ENV_API_BASE}/v1/tenant`;

    const { data } = await axios.get(url);
    return data;
}

async function getInstanceList() {
    const { data } = await axios.get(`${config.REACT_APP_ENV_API_BASE}/v1/instance`);
    return data;
}

async function getModuleList() {
    const { data } = await axios.get(`${config.REACT_APP_ENV_API_BASE}/v1/module`);
    return data;
}

interface ModuleAssociationPayload {
    tenantId: number;
    moduleId: number;
    activeFlg: boolean; 
}

async function updateTenantModuleStatus(payload: ModuleAssociationPayload) {
    const { data } = await axios.put(
        `${config.REACT_APP_ENV_API_BASE}/v1/tenant/module-association`,
        {
            tenantModulesTenantId: payload.tenantId,
            tenantModulesModuleId: payload.moduleId,
            activeFlag: payload.activeFlg ? 'Y' : 'N', 
        }
    );
    return data;
}


async function decommissionInstance(instanceId: number) {
    const { data } = await axios.post(
        `${config.REACT_APP_ENV_API_BASE}/v1/instance/decommission/${instanceId}`,
    );
    return data;
}

async function decommissionTenant(tenantId: number) {
    const { data } = await axios.post(
        `${config.REACT_APP_ENV_API_BASE}/v1/tenant/decommission/${tenantId}`,
    );
    return data;
}

async function suspensionTenant(tenantId: number) {
    const { data } = await axios.post(
        `${config.REACT_APP_ENV_API_BASE}/v1/tenant/suspension/${tenantId}`,
    );
    return data;
}

async function reactivationTenant(tenantId: number) {
    const { data } = await axios.post(
        `${config.REACT_APP_ENV_API_BASE}/v1/tenant/unsuspend/${tenantId}`,
    );
    return data;
}


export {
    getEnvironmentDetails,
    getTenantList,
    getInstanceList,
    getModuleList,
    updateTenantModuleStatus,
    decommissionInstance,
    decommissionTenant,
    suspensionTenant,
    reactivationTenant
};
